<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Procedimentos"
            description="Exportação de produção em XLS"
            url="/producao"
          />
        </div>
      </div>
      <div class="row">
        <div class="step" v-show="step == 0">
          <h2>
            Selecionar e enviar para a direita as colunas que você deseja na
            tabela.
          </h2>
          <div class="container-colunas">
            <div class="lista lista-adicionar">
              <div class="add-all" @click="addAll('right')">
                Adicionar todos
              </div>
              <div>
                <ul>
                  <li
                    v-for="item in lista"
                    :key="item.text"
                    @click="moveItem('right', item)"
                  >
                    <div
                      :class="{ 'selected-item': item === selected }"
                      class="c-item"
                    >
                      {{ item.text }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="lista lista-remover">
              <div class="add-all" @click="addAll('left')">Remover todos</div>
              <div>
                <ul>
                  <li
                    v-for="item in listaColunas"
                    :key="item.text"
                    @click="moveItem('left', item)"
                  >
                    <div
                      :class="{ 'selected-item': item === selected }"
                      class="c-item"
                    >
                      {{ item.text }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="row container-botoes-step">
            <v-btn
              class="botao-step avancar"
              @click="nextStep()"
              :disabled="_disabledColunms"
            >
              Avançar
            </v-btn>
          </div>
        </div>

        <div class="step" v-show="step === 1">
          <!-- <h2>Período</h2> -->
          <div class="row mt-12 container-condicao">
            <div class="col-md-6">
              <div class="container-date">
                <span class="label">Data inicial</span>
                <input v-model="dateStart" type="date" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="container-date">
                <span class="label"> Data final</span>
                <input v-model="dateEnd" type="date" />
              </div>
            </div>
          </div>
          <div class="row mt-12">
            <div class="col-md-12">
              <div class="container-information">{{ _information }}</div>
            </div>
          </div>
          <div class="row mt-12">
            <div class="col-md-12">
              <div class="container-table">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th
                          class="text-left"
                          v-for="item in _headerFake"
                          :key="item.text"
                        >
                          {{ item.text }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in 4" :key="index">
                        <td
                          :class="[
                            {
                              'text-right': headerItem.value === 'qtd_proceds',
                            },
                            'text-left',
                          ]"
                          v-for="headerItem in _headerFake"
                          :key="headerItem.text"
                        >
                          {{
                            (headerItem.text === 'Agrupamentos' &&
                              index !== 0) ||
                            (headerItem.text === 'Período Inicial' &&
                              index !== 0) ||
                            (headerItem.text === 'Período Final' && index !== 0)
                              ? ''
                              : index === 2
                              ? '...'
                              : headerItem.value === 'co_cbo' &&
                                headerItem.text !== 'Agrupamentos'
                              ? 'CÓD CBO'
                              : headerItem.value === 'no_cbo' &&
                                headerItem.text !== 'Agrupamentos'
                              ? 'NOME CBO'
                              : headerItem.value === 'cnes' &&
                                headerItem.text !== 'Agrupamentos'
                              ? '12345678'
                              : headerItem.value === 'no_unidade_saude' &&
                                headerItem.text !== 'Agrupamentos'
                              ? 'NOME UBS'
                              : headerItem.value === 'profissional' &&
                                headerItem.text !== 'Agrupamentos'
                              ? '64974815498'
                              : headerItem.value === 'co_proced' &&
                                headerItem.text !== 'Agrupamentos' &&
                                index === 0
                              ? 'ABP003'
                              : headerItem.value === 'co_proced' &&
                                headerItem.text !== 'Agrupamentos' &&
                                index === 1
                              ? '030201080'
                              : headerItem.value === 'co_proced' &&
                                headerItem.text !== 'Agrupamentos' &&
                                index === 3
                              ? '010203040'
                              : headerItem.value === 'no_proced' &&
                                headerItem.text !== 'Agrupamentos'
                              ? 'NOME PROCEDIMENTO'
                              : headerItem.value === 'qtd_proceds' &&
                                headerItem.text !== 'Agrupamentos'
                              ? Math.floor(Math.random() * (99 - 10 + 1) + 10)
                              : headerItem.value
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </div>
          </div>
          <div class="row container-botoes-step">
            <v-btn class="botao-step voltar step-2" @click="prevStep()"
              >Voltar</v-btn
            >
            <div>
              <download-excel
                :fetch="gerarArquivo"
                :fields="fields"
                :before-generate="startDownload"
                :before-finish="finishDownload"
                worksheet="My Worksheet"
                :name="`procedimentos_${this.dateStart
                  .split('-')
                  .reverse()
                  .join('/')}a${this.dateEnd
                  .split('-')
                  .reverse()
                  .join('/')}.xls`"
                class="dropdown-files-xls"
                :class="{ disabled: _disabledDates }"
              >
                <div v-if="loading">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </div>
                <div v-else>
                  <i class="icofont-file-excel"></i> Gerar arquivo XLS
                </div>
              </download-excel>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import utils from '@/mixins/utils.js'

export default {
  name: 'procedimentos',
  metaInfo: {
    title: 'Procedimentos',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    DownloadFiles,
  },
  data() {
    return {
      step: 0,
      selected: null,
      lista: [
        { text: 'Unidade de Saúde', value: 'no_unidade_saude' },
        { text: 'CNES', value: 'cnes' },
        { text: 'Código do CBO', value: 'co_cbo' },
        { text: 'Descrição do CBO', value: 'no_cbo' },
        { text: 'CPF do profissional', value: 'profissional' },
      ],
      listaColunas: [
        { text: 'Código do procedimento', value: 'co_proced' },
        { text: 'Nome do procedimento', value: 'no_proced' },
      ],
      dateStart: '',
      dateEnd: '',
      fields: {},
      dataFields: [],
      loading: false,
      headerFake: [],
      itemsFake: [],
    }
  },
  mixins: [utils],
  created() {
    const dates = this.obterDataAtualE30DiasAtras()
    this.dateStart = dates.data30DiasAtras
    this.dateEnd = dates.dataAtual
  },
  computed: {
    _headerFake() {
      this.headerFake = []
      const ordemDesejada = [
        'co_proced',
        'no_proced',
        'cnes',
        'no_unidade_saude',
        'co_cbo',
        'no_cbo',
        'profissional',
      ]

      for (const coluna of ordemDesejada) {
        const colunaEncontrada = this.listaColunas.find(
          (item) => item.value === coluna
        )
        if (colunaEncontrada) {
          this.headerFake.push(colunaEncontrada)
        }
      }

      const ordem = ['co_proced', 'cnes', 'co_cbo', 'profissional']
      const agrupado = []
      for (const coluna of ordem) {
        const colunaEncontrada = this.listaColunas.find(
          (item) => item.value === coluna
        )
        if (colunaEncontrada) {
          agrupado.push(colunaEncontrada)
        }
      }
      this.headerFake.push(
        {
          text: 'Quantidade de procedimentos',
          value: 'qtd_proceds',
        },
        {
          text: 'Agrupamentos',
          value: agrupado.map((el) => el.value).join(', '),
        },
        {
          text: 'Período Inicial',
          value: this._startDateBr,
        },
        {
          text: 'Período Final',
          value: this._endDateBr,
        }
      )

      return this.headerFake
    },

    _disabledColunms() {
      return this.step === 0 && this.listaColunas.length === 0
    },
    _disabledGroups() {
      return this.step === 1 && this.agrupar.length === 0
    },
    _disabledDates() {
      if (this.step === 1) {
        if (
          !this.isValidDate(this.dateStart) ||
          !this.isValidDate(this.dateEnd) ||
          this.dateStart > this.dateEnd
        ) {
          return true
        }
      }
      return false
    },
    _startDateBr() {
      return this.dateStart.split('-').reverse().join('/')
    },
    _endDateBr() {
      return this.dateEnd.split('-').reverse().join('/')
    },
    _information() {
      let message = ''
      const colCnes = this.listaColunas.find((col) => col.value === 'cnes')
      const colCBO = this.listaColunas.find((col) => col.value === 'no_cbo')
      if (colCnes) {
        message = 'por Unidade de Saúde'
      }
      if (colCBO) {
        message = 'por CBO'
      }
      if (colCnes && colCBO) {
        message = 'por Unidade de Saúde e CBO'
      }
      return `Pré-visualização da quantidade de procedimentos ${message} realizados no período de ${this._startDateBr} a ${this._endDateBr}`
    },
  },
  methods: {
    isValidDate(date) {
      return date && date.length === 10
    },
    addAll(direction) {
      if (direction === 'right') {
        const itemsToAdd = this.lista.filter(
          (item) =>
            item.text !== 'Código do procedimento' &&
            item.text !== 'Nome do procedimento'
        )
        this.listaColunas = this.listaColunas.concat(itemsToAdd)

        this.lista = this.lista.filter(
          (item) =>
            item.text === 'Código do procedimento' ||
            item.text === 'Nome do procedimento'
        )
      } else if (direction === 'left') {
        const itemsToAdd = this.listaColunas.filter(
          (item) =>
            item.text !== 'Código do procedimento' &&
            item.text !== 'Nome do procedimento'
        )
        this.lista = this.lista.concat(itemsToAdd)

        this.listaColunas = this.listaColunas.filter(
          (item) =>
            item.text === 'Código do procedimento' ||
            item.text === 'Nome do procedimento'
        )
      }
    },
    nextStep() {
      if (this.step < 2) {
        this.step++
      }
    },
    prevStep() {
      if (this.step > 0) {
        this.step--
      }
    },
    moveItem(direction, item) {
      if (
        item.text !== 'Código do procedimento' &&
        item.text !== 'Nome do procedimento'
      ) {
        if (direction === 'right') {
          const isAlreadyInRightList = this.listaColunas.some(
            (col) => col.value === item.value
          )
          if (!isAlreadyInRightList) {
            this.listaColunas.push(item)
            if (item.value === 'cnes') {
              const noUnidadeSaudeItem = this.lista.find(
                (col) => col.value === 'no_unidade_saude'
              )
              if (noUnidadeSaudeItem) {
                this.listaColunas.push(noUnidadeSaudeItem)
                this.lista = this.lista.filter(
                  (col) =>
                    col.value !== item.value && col.value !== 'no_unidade_saude'
                )
              }
            } else if (item.value === 'no_unidade_saude') {
              const cnesItem = this.lista.find((col) => col.value === 'cnes')
              if (cnesItem) {
                this.listaColunas.push(cnesItem)
                this.lista = this.lista.filter(
                  (col) => col.value !== item.value && col.value !== 'cnes'
                )
              }
            }
            if (item.value === 'co_cbo') {
              const descricaoCboItem = this.lista.find(
                (col) => col.value === 'no_cbo'
              )
              if (descricaoCboItem) {
                this.listaColunas.push(descricaoCboItem)
                this.lista = this.lista.filter(
                  (col) => col.value !== item.value && col.value !== 'no_cbo'
                )
              }
            } else if (item.value === 'no_cbo') {
              const codigoCboItem = this.lista.find(
                (col) => col.value === 'co_cbo'
              )
              if (codigoCboItem) {
                this.listaColunas.push(codigoCboItem)
                this.lista = this.lista.filter(
                  (col) => col.value !== item.value && col.value !== 'co_cbo'
                )
              }
            } else {
              this.lista = this.lista.filter((col) => col.value !== item.value)
            }
          }
        } else if (direction === 'left') {
          const isAlreadyInLeftList = this.lista.some(
            (col) => col.value === item.value
          )
          if (!isAlreadyInLeftList) {
            this.lista.push(item)
            if (item.value === 'cnes') {
              const noUnidadeSaudeItem = this.listaColunas.find(
                (col) => col.value === 'no_unidade_saude'
              )
              if (noUnidadeSaudeItem) {
                this.lista.push(noUnidadeSaudeItem)
                this.listaColunas = this.listaColunas.filter(
                  (col) =>
                    col.value !== item.value && col.value !== 'no_unidade_saude'
                )
              }
            } else if (item.value === 'no_unidade_saude') {
              const cnesItem = this.listaColunas.find(
                (col) => col.value === 'cnes'
              )
              if (cnesItem) {
                this.lista.push(cnesItem)
                this.listaColunas = this.listaColunas.filter(
                  (col) => col.value !== item.value && col.value !== 'cnes'
                )
              }
            } else {
              this.listaColunas = this.listaColunas.filter(
                (col) => col.value !== item.value
              )
            }
          }
        }
      }
    },

    startDownload() {
      // Converta as datas de strings para objetos Date
      const dataInicial = new Date(this.dateStart)
      const dataFinal = new Date(this.dateEnd)
      // Calcule a diferença em milissegundos entre as duas datas
      const diferencaEmMilissegundos = dataFinal - dataInicial
      // Calcule a diferença em dias
      const diferencaEmDias = diferencaEmMilissegundos / (1000 * 3600 * 24)
      // Verifique se a diferença em dias é maior do que 30
      if (diferencaEmDias > 30) {
        return false
      }
      this.loading = true
    },

    finishDownload() {
      this.loading = false
    },

    async gerarArquivo() {
      if (!this._disabledDates) {
        // Converta as datas de strings para objetos Date
        const dataInicial = new Date(this.dateStart)
        const dataFinal = new Date(this.dateEnd)
        // Calcule a diferença em milissegundos entre as duas datas
        const diferencaEmMilissegundos = dataFinal - dataInicial
        // Calcule a diferença em dias
        const diferencaEmDias = diferencaEmMilissegundos / (1000 * 3600 * 24)
        // Verifique se a diferença em dias é maior do que 30
        if (diferencaEmDias > 30) {
          this.$toast.error(
            'O período entre as datas não pode ser maior do que 30 dias.',
            '',
            {
              position: 'topRight',
            }
          )
          return false
        }

        const ordem = ['co_proced', 'cnes', 'co_cbo', 'profissional']
        const agrupado = []
        for (const coluna of ordem) {
          const colunaEncontrada = this.listaColunas.find(
            (item) => item.value === coluna
          )
          if (colunaEncontrada) {
            agrupado.push(colunaEncontrada)
          }
        }
        const payload = {
          cod_ibge: this.$store.state.cod_ibge,
          colunas: this.listaColunas.map((el) => el.value).join(','),
          agrupar: agrupado.map((el) => el.value).join(','),
          data_inicio: this.dateStart,
          data_fim: this.dateEnd,
        }

        try {
          let response = await this.$api.post('/app/procedimentos', payload)
          this.loading = true

          if (response) {
            const ordemDesejada = [
              'co_proced',
              'no_proced',
              'cnes',
              'no_unidade_saude',
              'co_cbo',
              'no_cbo',
              'profissional',
            ]

            const ordenado = []
            for (const coluna of ordemDesejada) {
              const colunaEncontrada = this.listaColunas.find(
                (item) => item.value === coluna
              )
              if (colunaEncontrada) {
                ordenado.push(colunaEncontrada)
              }
            }

            this.fields = {}
            this.dataFields = response.data
            for (const coluna of ordenado) {
              this.fields[coluna.text] = coluna.value
            }
            this.fields['Quantidade de procedimentos'] = 'qtd_proceds'
            this.fields['Agrupamentos'] = 'agrupamentos'
            this.fields['Período Inicial'] = 'periodo_inicial'
            this.fields['Período Final'] = 'periodo_final'

            /**
             * O CPF precisa ser tratando para retornar um string com um espaço em branco na frente para ser possível a exibição do xls
             */
            if (this.fields['CPF do profissional'] != undefined) {
              this.fields['CPF do profissional'] = {
                callback: (value) => {
                  if (
                    value.profissional !== '' &&
                    value.profissional !== null &&
                    value.profissional !== undefined
                  ) {
                    return `​  ​​${value.profissional.toString()}`
                  } else {
                    return ''
                  }
                },
              }
            }

            /**
             * O código do procedimento precisa ser tratando para retornar um string com um espaço em branco na frente para ser possível a exibição do xls
             */
            if (this.fields['Código do procedimento'] != undefined) {
              this.fields['Código do procedimento'] = {
                callback: (value) => {
                  if (
                    value.co_proced !== '' &&
                    value.co_proced !== null &&
                    value.co_proced !== undefined
                  ) {
                    return `​  ​​${value.co_proced.toString()}`
                  } else {
                    return ''
                  }
                },
              }
            }

            this.loading = false
            this.$toast.success('XLS criado com sucesso', 'Sucesso:', {
              position: 'topRight',
            })

            const resultado = response.data.map((item, index) => {
              if (index === 0) {
                return {
                  ...item,
                  agrupamentos: agrupado.map((el) => el.text).join(', '),
                  periodo_inicial: this.dateStart
                    .split('-')
                    .reverse()
                    .join('/'),
                  periodo_final: this.dateEnd.split('-').reverse().join('/'),
                }
              } else {
                return {
                  ...item,
                  agrupamentos: '',
                  periodo_inicial: '',
                  periodo_final: '',
                }
              }
            })
            return resultado
          }
        } catch (error) {
          this.$toast.error(error, 'Error:', {
            position: 'topRight',
          })
          return
        } finally {
          this.loading = false
        }
      }
      this.$toast.error('Preencha as datas corretamente', 'Erro:', {
        position: 'topRight',
      })
    },
  },
}
</script>

<style scoped lang="scss" src="./styles.scss" />
